import React, { useEffect, useState } from 'react'

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BiCheck } from "react-icons/bi";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

function CheckoutStepTwo(props) {
    // props
    const {
        cartDetails,

        allowedToDisplay,
        allCheckoutDetails,
        setAllCheckoutDetails,

        setCheckoutCurrentStep,

        completedcheckoutSteps,
        setCompletedCheckoutSteps,

        shippingMethod,
        setShippingMethod,
    } = props

    // states
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [sectionLoading, setSectionLoading] = useState(false)

    const [selectedShippingMethodName, setSelectedShippingMethodName] = useState("Regular Shipping")

    // initial form values
    const initialFormValues = {
        shippingMethod: "RegularShipping",
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        shippingMethod: Yup.string().required('This field is required'),
    })


    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // console.log("values ", values);
            setShippingMethod(selectedShippingMethodName)

            setAllCheckoutDetails({ ...allCheckoutDetails, ...values })

            setCompletedCheckoutSteps([...completedcheckoutSteps, "step2"])

            setCheckoutCurrentStep("step3")

            window.scrollTo(0, 0)
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // shipping method change
    const handleShippingMethodChange = (ev, name) => {
        const inpVal = ev.target.value
        if (inpVal) {
            formik.setFieldValue("shippingMethod", inpVal)

            // setting method name to show
            setSelectedShippingMethodName(name)
        }
    }

    // when user wants to shipping method
    const handleChangeMethod = (ev) => {
        ev.preventDefault()
        // const updatedSteps = completedcheckoutSteps.filter(item => item !== "step2")

        setCompletedCheckoutSteps(["step1"])
    }

    // setting default
    useEffect(() => {
        if (cartDetails && Object.keys(cartDetails)?.length) {
            formik.submitForm() // submits the form
            window.scrollTo(0, 0) // scrolling windows to the top
        }
    }, [cartDetails])


    return (
        <React.Fragment>
            {
                allowedToDisplay ? (
                    <React.Fragment>
                        {
                            completedcheckoutSteps?.length && completedcheckoutSteps.find(item => item === "step2") ? (
                                <div className="after-header border-bottom pb-3 mb-3">
                                    <div className="ah-inner d-flex">
                                        <div className="check me-3 d-flex align-items-center justify-content-center">
                                            <BiCheck fontSize={23} color={"#333"} />
                                        </div>
                                        <div className="content media-body st-fs-15">
                                            <p className="head st-fw-600 mb-0">Shipping method</p>
                                            <p className="info mb-0">
                                                <span className="st-fw-600">{shippingMethod}</span>
                                                {/* <span className="ms-3 st-fs-14 cursor-pointer" onClick={handleChangeMethod}>Change Method</span> */}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="content-view mb-3">
                                    <div className="cv-inner">
                                        <div className="head-container mb-3">
                                            <p className="head mb-1 st-fs-25">Shipping method</p>
                                        </div>

                                        <div className="form-content position-relative step2">
                                            <form
                                                onSubmit={formik.handleSubmit}
                                                noValidate
                                                autoComplete="off">
                                                <label className="shipping-method-label d-block cursor-pointer">
                                                    <input type="radio"
                                                        value="RegularShipping"
                                                        className="d-none"
                                                        checked={formik.values.shippingMethod === "RegularShipping"}
                                                        onChange={ev => handleShippingMethodChange(ev, "Regular Shipping")}
                                                    />
                                                    <span className="main d-flex align-items-center">
                                                        <span className="round d-flex align-items-center justify-content-center"></span>
                                                        <span className="text d-flex media-body ps-3">
                                                            <div className="lt">
                                                                <span className="d-block head st-fw-600">Regular Shipping</span>
                                                                {/* <span className="d-block desc st-fs-14">Estimated arrival on: Oct 30 — Nov 4</span> */}
                                                            </div>
                                                            <div className="rt ms-auto ps-2">
                                                                <span className="d-block price st-fs-14">Free</span>
                                                            </div>
                                                        </span>
                                                    </span>
                                                </label>

                                                {/* btns */}
                                                <div className="btns w-100 pt-2">
                                                    <button type="submit" className="btn" disabled={btnDisabled}>
                                                        Continue
                                                    </button>
                                                </div>
                                            </form>

                                            {
                                                /* LOADING */
                                                sectionLoading ? (
                                                    <div className="section-loading position-absolute align-items-center d-flex h-100 justify-content-center section-loading w-100" style={{ top: 0, left: 0, background: "rgba(255,255,255,0.5)" }}>
                                                        <Spinner animation="border" />
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            )

                        }
                    </React.Fragment>
                ) : null
            }
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        // currentUser: state.auth.currentUser,
    };
};

export default connect(getDataFromStore, null)(CheckoutStepTwo);